import React from "react";
import { withRouter } from "react-router-dom";
import { apiCallPost, niceDate, niceDateTime } from "./fns/util";
import _ from "lodash";
import { Button, Input, Space, Table, Tag, Spin, Alert } from "antd";

// class PublicCommitmentList extends React.Component {
//   constructor(props) {
//     super(props);
//   }
//   state = {};

//   async componentDidMount() {
//     const delegateId = this.props.match.params.delegateId;
//     let res = await apiCallPost(
//       "NOT_AUTHED",
//       "/conference2023/getMyCommitments",
//       {
//         delegateId: delegateId,
//       }
//     );
//   }

//   render() {
//     return <div>Public Commitment List</div>;
//   }
// }

class PublicCommitmentList extends React.Component {
  state = {
    dataSource: [],
    columns: [
      {
        title: "Day",
        key: "onDay",
        dataIndex: "onDay",
      },
      {
        title: "Venue",
        key: "location",
        dataIndex: "location",
      },
      {
        title: "Timings",
        key: "timings",
        dataIndex: "timings",
      },
      {
        title: "Session",
        key: "title",
        dataIndex: "title",
      },
      {
        title: "Role",
        key: "role",
        dataIndex: "role",
      },
    ],
    isLoading: true,
  };

  async componentDidMount() {
    const delegateId = this.props.match.params.delegateId;
    let res = await apiCallPost(
      "NOT_AUTHED",
      "/conference2023/getMyCommitments",
      {
        delegateId: delegateId,
      }
    );
    this.setState({
      isLoading: false,
      dataSource: _.sortBy(res.commitments, "start"),
      delegateName: res.delegateName,
    });
  }

  transformToTableForm = () => {
    let results = this.state.results;
    let data = results;
    if (this.state.searchString) {
      data = results.filter((item) => {
        return item.title
          .toLowerCase()
          .includes(this.state.searchString.toLowerCase());
      });
    }
    let dataSource = data;
    let columns = [
      {
        title: "#",
        key: "serialNumber",
        dataIndex: "serialNumber",
      },
      {
        title: "Type",
        key: "submissionType",
        dataIndex: "submissionType",
        render: (x, record) => {
          return (
            <Tag>
              {record.submissionType === "IC"
                ? "IC"
                : _.startCase(_.lowerCase(record.submissionType))}
            </Tag>
          );
        },
        filters: [
          {
            text: "Paper",
            value: "PAPER",
          },
          {
            text: "Poster",
            value: "POSTER",
          },
          {
            text: "Video",
            value: "VIDEO",
          },
          {
            text: "Instruction Course",
            value: "IC",
          },
          {
            text: "OPC",
            value: "OPC",
          },
          {
            text: "PGT Thesis",
            value: "THESIS",
          },
        ],
        onFilter: (value, record) => {
          return record.submissionType === value;
        },
      },
      { title: "Title", key: "title", dataIndex: "title" },
      {
        title: "Primary Author",
        key: "presentingAuthorName",
        dataIndex: "presentingAuthorName",
      },
      {
        title: "Authors",
        key: "authors",
        dataIndex: "authors",
        render: (x, record) => {
          return (
            <p className="smaller_text">
              {_.join(
                _.map(
                  record.authors,
                  (a) => `${a.name} [${a.email} | ${a.mobile}]`
                ),
                ", "
              )}
            </p>
          );
        },
      },
      {
        title: "Award Track",
        key: "awardTrack",
        dataIndex: "awardTrack",
        filters: [
          {
            text: "Paper",
            value: "PAPER",
            children: [
              {
                text: "Dr B K Mitra Competition for Papers",
                value: "Dr B K Mitra Competition for Papers",
              },
              {
                text: "Dr K P Roy Competition for Papers",
                value: "Dr K P Roy Competition for Papers",
              },
              {
                text: "Smt Satya Rani Hazra Competition for Papers in Community Ophthalmology",
                value:
                  "Smt Satya Rani Hazra Competition for Papers in Community Ophthalmology",
              },
            ],
          },
          {
            text: "Poster",
            value: "POSTER",
            children: [
              {
                text: "Dr Anadi Bhushan Basu Competition for Posters",
                value: "Dr Anadi Bhushan Basu Competition for Posters",
              },
            ],
          },
          {
            text: "Video",
            value: "VIDEO",
            children: [
              {
                text: "Smt Sovabati Das Ghosh Competition for Videos",
                value: "Smt Sovabati Das Ghosh Competition for Videos",
              },
            ],
          },
          {
            text: "Other",
            value: "OTHER",
            children: [
              {
                text: "<None Selected>",
                value: "",
              },
            ],
          },
        ],
        onFilter: (value, record) => {
          if (value == null) {
            return true;
          } else {
            return record.awardTrack === value;
          }
        },
      },
      {
        title: "Status",
        key: "lifecycle",
        dataIndex: "lifecycle",
        render: (x, record) => {
          let colorMap = {
            DRAFT: "orange",
            SUBMITTED: "blue",
            WITHDRAWN: "red",
            ACCEPTED: "green",
            REJECTED: "red",
          };
          if (record.submissionType === "VIDEO") {
            if (record.videoList && record.videoList.length > 0) {
              return (
                <Tag color={colorMap[record.lifecycle]}>
                  {_.startCase(_.lowerCase("Video Uploaded"))}
                </Tag>
              );
            }
          }
          return (
            <Tag color={colorMap[record.lifecycle]}>
              {_.startCase(_.lowerCase(record.lifecycle))}
            </Tag>
          );
        },
        filters: [
          {
            text: "Draft",
            value: "DRAFT",
          },
          {
            text: "Submitted",
            value: "SUBMITTED",
          },
          {
            text: "Accepted",
            value: "ACCEPTED",
          },
          {
            text: "Rejected",
            value: "REJECTED",
          },
          {
            text: "Withdrawn",
            value: "WITHDRAWN",
          },
        ],
        onFilter: (value, record) => {
          return record.lifecycle === value;
        },
      },
      {
        title: "Metadata",
        key: "createdAt",
        render: (x, record) => {
          return (
            <p className="smaller_text">
              Created by <b>{record.createdByName}</b> on{" "}
              {niceDateTime(record.createdAt)}. Last updated:{" "}
              {niceDateTime(record.updatedAt)}
            </p>
          );
        },
      },
      /*   {
        title: "Action",
        key: "action",
        render: (x, record) => {
          return <>{this.renderActionBar(record)}</>;
        },
      }, */
    ];
    this.setState({
      dataSource,
      columns,
    });
  };

  render() {
    // Check if data is still loading
    if (this.state.isLoading) {
      return (
        <div>
          <Spin />
        </div>
      );
    }
    // Check if there was an error loading the data
    if (this.state.isError) {
      return (
        <Alert
          message="Error"
          description="An error occurred while loading the data."
          type="error"
          showIcon
        />
      );
    }

    return (
      <div
        style={{
          marginTop: "20px",
          marginLeft: "20px",
          marginRight: "20px",
        }}
      >
        <h3>{this.state.delegateName}'s Commitments</h3>
        <Table
          //   key={keyString}
          onRow={(record) => {
            return {
              onClick: () => {
                this.setState({
                  showDrawer: true,
                  selectedRecord: record,
                });
              },
            };
          }}
          dataSource={[...this.state.dataSource]}
          columns={this.state.columns}
          rowKey={(record) => {
            return `submission__${record._id}__${record.updatedAt}__`;
          }}
          size="small"
          pagination={{
            defaultPageSize: 100,
          }}
        />
      </div>
    );
  }
}

export default withRouter(PublicCommitmentList);
